import React from 'react';
import {Button, Form} from 'semantic-ui-react';
import {Field, reduxForm} from 'redux-form';
import TextArea from "../../../components/form/TextArea";
import {openModal} from "../../../features/modals/modalActions";
import {useDispatch} from "react-redux";
import {addPostComment} from "./PostDetailsActions";
import {combineValidators, isRequired} from "revalidate";

import 'semantic-ui-css/components/button.min.css'
import 'semantic-ui-css/components/form.min.css'
import {auth} from "../../../config/firebase";

const validate = combineValidators({
    comment: isRequired('comment')
});


const PostDetailsCommentForm = ({reset, closeForm, parentId, postId, postAuthorId, handleSubmit, isEmpty}) => {
    const userId = auth.currentUser?.uid;
    const dispatch = useDispatch()
    const handleCommentSubmit = values => {
        if (userId) {
            dispatch(addPostComment(postId, values, parentId, postAuthorId));
            reset();
            if (parentId) {
                closeForm();
            }
        } else {
            dispatch(openModal('UnauthModal'));
        }
    };

    return (
        <Form onSubmit={handleSubmit(handleCommentSubmit)}>
            <Field name='comment' type='text' component={TextArea} rows={2}
                   placeholder={isEmpty ? "Be the first to comment to win prizes" : "Comment to join the conversation"}/>
            <Button content='Add Reply' labelPosition='left' icon='edit' primary/>
        </Form>
    );
}

export default reduxForm({Fields: 'comment', validate})(PostDetailsCommentForm);
